<template>
  <vue-scroll>
    <rabbey-toolbox :filterables="true" @filter-search="filterSearch">
      <div class="mr-5">
        <yearcomponent @change="handler_year" class="box-item"></yearcomponent>
      </div>
    </rabbey-toolbox>
    <rabbey-table2 :columns="columns" />
  </vue-scroll>
</template>

<script>
import { mapActions } from "vuex";
import TargetCell from "@/components/functionals/TargetCell.vue";
import yearcomponent from "@/components/Global_System/YearsComponent.vue";

export default {
  name: "GoalsPerSeller",
  components: { yearcomponent },
  data() {
    const currentYear = new Date().getFullYear();

    return {
      year: currentYear,
      yearSelected: null,
      columns: [
        {
          prop: "User",
          name: "Vendedor",
          fixed: true,
          minWidth: 200,
          formatter: (row) => row.User.FullName
        },

        {
          prop: "January",
          name: "Enero",
          formatter: TargetCell,
          cellAtrrs: {
            month: 1,
            year: this.getYearSelected2
          }
        },
        {
          prop: "February",
          name: "Febrero",
          formatter: TargetCell,
          cellAtrrs: {
            month: 2,
            year: this.getYearSelected2
          }
        },
        {
          prop: "March",
          name: "Marzo",
          formatter: TargetCell,
          cellAtrrs: {
            month: 3,
            year: this.getYearSelected2
          }
        },
        {
          prop: "April",
          name: "Abril",
          formatter: TargetCell,
          cellAtrrs: {
            month: 4,
            year: this.getYearSelected2
          }
        },
        {
          prop: "May",
          name: "Mayo",
          formatter: TargetCell,
          cellAtrrs: {
            month: 5,
            year: this.getYearSelected2
          }
        },
        {
          prop: "July",
          name: "Julio",
          formatter: TargetCell,
          cellAtrrs: {
            month: 6,
            year: this.getYearSelected2
          }
        },
        {
          prop: "June",
          name: "Junio",
          formatter: TargetCell,
          cellAtrrs: {
            month: 7,
            year: this.getYearSelected2
          }
        },
        {
          prop: "August",
          name: "Agosto",
          formatter: TargetCell,
          cellAtrrs: {
            month: 9,
            year: this.getYearSelected2
          }
        },
        {
          prop: "September",
          name: "Septiembre",
          formatter: TargetCell,
          cellAtrrs: {
            month: 10,
            year: this.getYearSelected2
          }
        },
        {
          prop: "October",
          name: "November",
          formatter: TargetCell,
          cellAtrrs: {
            month: 11,
            year: this.getYearSelected2
          }
        },
        {
          prop: "December",
          name: "Diciembre",
          formatter: TargetCell,
          cellAtrrs: {
            month: 12,
            year: this.getYearSelected2
          }
        }
      ],
      list: []
    };
  },
  async created() {
    const currentYear = new Date().getFullYear();

    this.list = await this.getItems({
      url: "/api/SalesApi/GetGoalOfVendor",
      params: {
        Year: currentYear,
        companyID: this.currentCompany
      }
    });
  },
  methods: {
    ...mapActions({ getItems: "rabbey_table/getItems" }),
    runGetItems() {
      const params = {
        Year: this.year,
        companyID: this.currentCompany
      };
      this.$store.commit("rabbey_table/loading");
      this.$http
        .get("/api/SalesApi/GetGoalOfVendor", {
          params: params
        })
        .then(({ data }) => {
          this.items = data;
          this.$store.commit("rabbey_table/items", data);
        })
        .finally(() => {
          this.$store.commit("rabbey_table/success");
          this.principalTable = false;
        });
    },
    handler_year(_year) {
      this.year = _year;
      this.runGetItems();
    },
    filterSearch() {
      this.runGetItems(this.year);
    },
    getYearSelected2() {
      return this.year;
    }
  },
  computed: {
    renderYears() {
      const currentYear = new Date().getFullYear();
      const range = (start, stop, step) =>
        Array.from(
          { length: (stop - start) / step + 1 },
          (_, i) => start + i * step
        );

      return range(currentYear, currentYear - 10, -1);
    },
    years() {
      let b = [];

      this.renderYears.forEach((year) => {
        b.push({ label: year.toString(), value: year });
      });

      return b;
    },
    getYearSelected() {
      return this.year;
    }
  }
};
</script>

<style></style>
